import BaseEntity from '../BaseEntity';
import { BoxOutlineModel as BoxOutlineModel2d } from '../2d/boxOutlineModel';
import { BoxOutlineModel as BoxOutlineModel3d } from '../3d/boundingBox/boxOutlineModel';
import { isNumber } from 'lodash-es';
import { IBoxOutlineParams } from '../type';

export default class BoxSelectedEntity extends BaseEntity {
  protected override _model2d: BoxOutlineModel2d;
  protected override _model3d: BoxOutlineModel3d;
  private _params: IBoxOutlineParams = {
    color: 0x000000,
    width: 0,
    thickness: 0,
    height: 0,
    x: 0,
    y: 0,
    z: 0,
    rotation: 0,
    linewidth: 1
  };
  private _created: boolean = false;

  constructor() {
    super();

    this._model2d = new BoxOutlineModel2d();
    this._model3d = new BoxOutlineModel3d();
  }

  get created() {
    return this._created;
  }

  override update(params: Partial<IBoxOutlineParams>) {
    let noDestroyUpdate = false;
    let needDestroyUpdate = !this._created || false;

    if (isNumber(params.width) && this._params.width !== params.width) {
      this._params.width = params.width;
      needDestroyUpdate = true;
    }
    if (isNumber(params.thickness) && this._params.thickness !== params.thickness) {
      this._params.thickness = params.thickness;
      needDestroyUpdate = true;
    }
    if (isNumber(params.height) && this._params.height !== params.height) {
      this._params.height = params.height;
      needDestroyUpdate = true;
    }
    if (params.color && this._params.color !== params.color) {
      this._params.color = params.color;
      noDestroyUpdate = true;
    }
    if (isNumber(params.linewidth) && this._params.linewidth !== params.linewidth) {
      this._params.linewidth = params.linewidth;
      noDestroyUpdate = true;
    }
    if (isNumber(params.x) && this._params.x !== params.x) {
      this._params.x = params.x;
      noDestroyUpdate = true;
    }
    if (isNumber(params.y) && this._params.y !== params.y) {
      this._params.y = params.y;
      noDestroyUpdate = true;
    }
    if (isNumber(params.z) && this._params.z !== params.z) {
      this._params.z = params.z;
      noDestroyUpdate = true;
    }
    if (isNumber(params.rotation) && this._params.rotation !== params.rotation) {
      this._params.rotation = params.rotation;
      noDestroyUpdate = true;
    }
    // renderOrder 只在建模时写进 Line2，改了必须重建
    if (isNumber(params.renderOrder) && this._params.renderOrder !== params.renderOrder) {
      this._params.renderOrder = params.renderOrder;
      needDestroyUpdate = true;
    }

    if (needDestroyUpdate) {
      this.clear();
      this._model2d.createModel({ ...this._params });
      this._model3d.createModel({ ...this._params });
      this._created = true;
    } else if (noDestroyUpdate) {
      this._model2d.update({ ...this._params });
      this._model3d.update({ ...this._params });
    }
  }

  clear() {
    this._model2d.clear();
    this._model3d.clearModel();
    this._created = false;
  }
}
